module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header",
    class: [_vm.isBackground ? 'active' : '']
  }, [_c('div', {
    staticClass: "sub-header-container"
  }, [(_vm.title) ? _c('div', {
    staticClass: "title px-0"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("sub-header-tab")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4184600a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubHeader.vue
// module id = 1571
// module chunks = 1